import { useIntl } from "react-intl";
function useColumnHeaderName(columns) {
  const { formatMessage } = useIntl();
  return columns?.map((column) => {
    const renderHeader = column?.renderHeader ? column?.localizedHeaderName ? () => column?.renderHeader(column?.localizedHeaderName) : () => column?.renderHeader("") : void 0;
    return {
      ...column,
      headerName: column?.headerName ?? (column?.localizedHeaderName ? formatMessage(column.localizedHeaderName) : " "),
      renderHeader
    };
  });
}
export {
  useColumnHeaderName
};
//# sourceMappingURL=useColumnHeaderName.js.map
